// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-dla-klienta-js": () => import("./../src/pages/dla-klienta.js" /* webpackChunkName: "component---src-pages-dla-klienta-js" */),
  "component---src-pages-dla-pracodawcy-js": () => import("./../src/pages/dla-pracodawcy.js" /* webpackChunkName: "component---src-pages-dla-pracodawcy-js" */),
  "component---src-pages-dla-pracownika-js": () => import("./../src/pages/dla-pracownika.js" /* webpackChunkName: "component---src-pages-dla-pracownika-js" */),
  "component---src-pages-e-sumienie-js": () => import("./../src/pages/e-sumienie.js" /* webpackChunkName: "component---src-pages-e-sumienie-js" */),
  "component---src-pages-faq-js": () => import("./../src/pages/faq.js" /* webpackChunkName: "component---src-pages-faq-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

